import React from 'react';

import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import useMediaQuery from 'hooks/use-media-query';

import { HAS_BORDER_AT_CHECKOUT_STYLES } from './styles.skeleton';

const SecondRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto) 1fr;
  column-gap: 5px;
`;

const WrapperLabel = styled.div`
  display: grid;
  align-items: center;
  height: fit-content;
  padding: 8px;
`;

const Container = styled.div<{ $hasBorderAtCheckout?: boolean }>`
  background-color: ${Styles.color.cardBackground};
  display: flex;
  height: 102px;
  align-items: center;
  min-width: 250px;
  padding: 20px 15px;
  margin: 5px 10px 5px 4px;
  border-radius: 8px;
  box-shadow: rgb(0 0 0 / 10%) 0px 2px 6px 0px;
  & {
    ${props => (props.$hasBorderAtCheckout ? HAS_BORDER_AT_CHECKOUT_STYLES : null)}
  }
`;

const WrapperAddButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
`;

export const UpsellSkeleton = ({ hasBorderAtCheckout }: { hasBorderAtCheckout?: boolean }) => {
  const isMobile = useMediaQuery('mobile');
  return (
    <Container data-testid="upsell-skeleton-loader" $hasBorderAtCheckout={hasBorderAtCheckout}>
      <Skeleton height="50px" width="70px" />
      <WrapperLabel>
        <Skeleton height="20px" width={isMobile ? '120px' : '160px'} />
        <SecondRow>
          <Skeleton height="20px" width={isMobile ? '26px' : '35px'} />
          <span>|</span>
          <Skeleton height="20px" width={isMobile ? '37px' : '50px'} />
        </SecondRow>
      </WrapperLabel>
      <WrapperAddButton>
        <Skeleton height="20px" width="20px" />
      </WrapperAddButton>
    </Container>
  );
};
